import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { interval } from 'rxjs';

export interface IUndoActionSnackBarData {
  message: string;
  actionLabel?: string;
  duration: number;
}

@Component({
  selector: 'pt-undo-action-snack-bar',
  templateUrl: './undo-action-snack-bar.component.html',
  styleUrls: ['./undo-action-snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule],
})
export class UndoActionSnackBarComponent {
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _startTime = Date.now();
  readonly snackBarRef = inject(MatSnackBarRef);
  readonly data = inject<IUndoActionSnackBarData>(MAT_SNACK_BAR_DATA);
  readonly elapsed = signal<number>(0);

  readonly secondsRemaining = computed(() =>
    Math.max(Math.ceil((this.data.duration - this.elapsed()) / 1000), 0)
  );

  readonly progressOffset = computed(() =>
    Math.min((this.elapsed() / this.data.duration) * 100, 100)
  );

  constructor() {
    interval(100)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        const newElapsed = Math.min(
          Date.now() - this._startTime,
          this.data.duration
        );
        this.elapsed.set(newElapsed);

        if (newElapsed >= this.data.duration) {
          this.snackBarRef.dismiss();
        }
      });
  }

  undo(): void {
    this.snackBarRef.dismissWithAction();
  }
}
